import { useEffect, useState, useCallback } from "react";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export const MONDAY = (d = new Date()) => { const x = new Date(d); x.setDate(x.getDate() - ((x.getDay() + 6) % 7)); return x.toISOString().slice(0, 10); };
export const addDays = (iso, n) => { const d = new Date(iso); d.setDate(d.getDate() + n); return d.toISOString().slice(0, 10); };
export const fmtH = (min) => min == null ? "N/A" : `${Math.floor(min / 60)}h${String(Math.abs(min) % 60).padStart(2, "0")}`;
export const fmtGap = (min) => min == null ? "N/A" : `${min > 0 ? "+" : ""}${min} min`;
export const initials = (c) => `${(c?.prenom || "")[0] || ""}${(c?.nom || "")[0] || ""}`.toUpperCase();
export const DAYS_FR = ["Lun", "Mar", "Mer", "Jeu", "Ven", "Sam", "Dim"];
export const fmtD = (iso) => iso ? iso.split("-").reverse().join("/") : "";

export function useStores() {
  const [stores, setStores] = useState([]);
  useEffect(() => { api.get("/stores").then(r => setStores((Array.isArray(r.data) ? r.data : r.data.items || []).filter(s => s.is_active !== false).sort((a, b) => (a.name || "").localeCompare(b.name || "")))).catch(() => {}); }, []);
  return stores;
}

export function useApi(path, params, deps = []) {
  const [data, setData] = useState(null); const [loading, setLoading] = useState(false);
  const reload = useCallback(() => {
    if (!path) return;
    setLoading(true); api.get(path, { params }).then(r => setData(r.data)).catch(e => toast.error(formatApiError(e))).finally(() => setLoading(false));
  }, [path, JSON.stringify(params)]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => { reload(); }, [reload, ...deps]); // eslint-disable-line react-hooks/exhaustive-deps
  return { data, loading, reload };
}

export const Card = ({ label, value, sub, tone = "", tip, testid }) => (
  <div className="rounded-xl border border-slate-200 bg-white p-4 shadow-sm" title={tip} data-testid={testid}>
    <div className="text-[10px] font-bold uppercase tracking-wider text-slate-500">{label}</div>
    <div className={`mt-1 text-2xl font-bold tabular-nums ${tone}`}>{value}</div>
    {sub && <div className="text-[11px] text-slate-500 mt-0.5">{sub}</div>}
  </div>
);

export const Drawer = ({ title, onClose, children, width = "max-w-md" }) => (
  <div className="fixed inset-0 z-[1000] flex justify-end" data-testid="pl-drawer">
    <div className="absolute inset-0 bg-black/40" onClick={onClose}/>
    <div className={`relative bg-white w-full ${width} h-full shadow-2xl overflow-y-auto flex flex-col`}>
      <div className="p-4 border-b border-slate-200 flex items-center justify-between"><h2 className="font-display font-bold text-slate-900">{title}</h2>
        <button onClick={onClose} className="text-slate-400 hover:text-slate-700 text-xl leading-none" data-testid="pl-drawer-close">×</button></div>
      <div className="p-4 space-y-3 flex-1">{children}</div>
    </div>
  </div>
);

export const Field = ({ label, children }) => (<label className="block text-xs"><span className="font-semibold text-slate-600">{label}</span><div className="mt-1">{children}</div></label>);
export const inputCls = "w-full h-9 rounded-md border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-orange-400";
export const btnPrimary = "inline-flex items-center gap-1.5 h-9 px-3 rounded-lg bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold disabled:opacity-50";
export const btnGhost = "inline-flex items-center gap-1.5 h-9 px-3 rounded-lg border border-slate-200 bg-white hover:bg-slate-50 text-slate-700 text-sm font-medium";

export const Anomalies = ({ list }) => !list?.length ? null : (
  <div className="rounded-lg border border-amber-200 bg-amber-50 p-2 space-y-1" data-testid="pl-anomalies">
    {list.map((a, i) => (
      <div key={i} className="text-[11px] text-amber-900"><span className={`font-bold ${a.blocking ? "text-rose-700" : ""}`}>⚠ {a.blocking ? "Bloquant" : "Attention"} · {a.rule}</span>
        <div>Constaté : <b>{a.observed}</b> · Seuil configuré : <b>{a.threshold}</b></div><div className="text-amber-700">{a.message}</div></div>
    ))}
  </div>
);
